module.exports = __webpack_public_path__ + "static/media/facebook.2e76b1da.svg";